import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_cursor_hand_closed.svg';
import Icon, { IconProps } from './icon';

const IconCursorHandClosed = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconCursorHandClosed;
